// removed by extract-text-webpack-plugin
module.exports = {"menuText":"#bfcbd9","menuActiveText":"#409EFF","subMenuActiveText":"#f4f4f5","menuBg":"#fff","menuHover":"#e1ebff","subMenuBg":"#1f2d3d","subMenuHover":"#001528","sideBarWidth":"222px"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/common.scss
// module id = 5Ia3
// module chunks = 34